<template>
  <dialog class="c-modal" v-if="isVisible">
    <div class="c-modal__inner">
      <button  v-if="closeButton" class="c-modal__close" type="button" @click="closeModal">
        <span>Close</span>
        <svg class="c-modal__close-icon" aria-hidden="true" focusable="false">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="#close-circle"
          ></use>
        </svg>
      </button>
      <div
        class="c-modal__content"
        :class="{ 'c-modal__content--closable': closeButton }"
      >
        <h2 class="c-modal__title">
          {{ title }}
        </h2>
        <p v-if="description" class="c-modal__description">{{description}}</p>
        <div class="c-modal__body">
          <slot></slot>
        </div>
        <div class="c-modal__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script>
  export default {
    components: {},
    props: {
      closeButton: {
        type: Boolean,
      },
      isVisible: {
        type: Boolean,
        default: false,
      },
      title: {
        required: true,
        type: String,
      },
      description: {
        type: String,
      },
    },
    data() {
      return {};
    },
    methods: {
      closeModal(e) {
        e.preventDefault();
        this.$emit('close'); 
      } 
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/_contact-us-rap/_vue/Modal.vue